<main class="sav-topics-page">
  <header class="sav-topics-hero">
    <div class="container">
      <app-breadcrumb [items]="crumbs" />
    </div>
    <div class="container sav-hero-wrap">
      <div class="sav-hero-text">
        <span class="sav-eyebrow">SavingArena Topic Hub</span>
        <h1>Find Smarter Ways To Save Online</h1>
        <p>
          Discover curated shopping topics, coupon strategies, seasonal sale guides, retailer deal
          hubs and expert savings content in one organized place.
        </p>

        <form class="sav-hero-search" role="search" (submit)="$event.preventDefault()">
          <input
            type="text"
            placeholder="Search topics..."
            aria-label="Search topics"
            [value]="searchTerm()"
            (input)="onSearchChange($any($event.target).value)"
          />
          <button type="submit">Search Topics</button>
        </form>

        @if (loaded()) {
          <p class="sav-hero-note">{{ totalTopics() }} topics • {{ totalGuides() }} guides</p>
        }
      </div>

      @if (trendingTopics().length > 0) {
        <div class="sav-hero-card">
          <!-- h2: this card sits in the hero, directly under the page H1 and before any other
               section, so an h3 here skipped a level. -->
          <h2>Most Guides</h2>

          <ul class="sav-hero-mini-list">
            @for (topic of trendingTopics(); track topic.slug) {
              <li>
                <a [routerLink]="'/blogs/' + topic.slug">
                  <strong>{{ topic.name }}</strong>
                  <span
                    >{{ topic.totalBlogs }} {{ topic.totalBlogs === 1 ? 'guide' : 'guides' }}</span
                  >
                </a>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </header>

  @if (featuredTopic(); as featured) {
    <section>
      <div class="container">
        <div class="sav-section-head">
          <div>
            <h2>Featured Saving Topics</h2>
            <p>Explore our most useful topics for coupons, online shopping and seasonal deals.</p>
          </div>
          <a [routerLink]="'/blogs'" class="sav-view-all">All Blog Guides -></a>
        </div>

        <div class="sav-featured-layout">
          <a [routerLink]="'/blogs/' + featured.slug" class="sav-big-topic">
            <span class="sav-topic-label">Featured Guide</span>
            <h3>{{ featured.name }}</h3>
            <p>{{ featured.description }}</p>
            <span class="sav-topic-link">Explore {{ featured.name }} -></span>
          </a>

          @for (topic of featuredTopics(); track topic.slug) {
            <a [routerLink]="'/blogs/' + topic.slug" class="sav-small-topic">
              <div>
                <div class="icon">{{ topic.initial }}</div>
                <h3>{{ topic.name }}</h3>
                <p>{{ topic.description }}</p>
              </div>
              <span class="sav-meta"
                >{{ topic.totalBlogs }} {{ topic.totalBlogs === 1 ? 'Article' : 'Articles' }}</span
              >
            </a>
          }
        </div>
      </div>
    </section>
  }

  @if (popularTopics().length > 0) {
    <section>
      <div class="container sav-main-grid">
        <aside class="sidebar">
          <h3>Browse By Topic</h3>
          @for (topic of sidebarTopics(); track topic.slug) {
            <a [routerLink]="'/blogs/' + topic.slug">{{ topic.name }}</a>
          }
        </aside>

        <div>
          <div class="sav-section-head">
            <div>
              <h2>Popular Topics</h2>
              <p>High-value topics users browse most often on SavingArena.</p>
            </div>
          </div>

          <div class="sav-topics-list-grid">
            @for (topic of popularTopics(); track topic.slug) {
              <a [routerLink]="'/blogs/' + topic.slug" class="sav-list-card">
                <div class="sav-list-icon">{{ topic.initial }}</div>
                <div>
                  <h3>{{ topic.name }}</h3>
                  <p>{{ topic.description }}</p>
                  <span
                    >{{ topic.totalBlogs }}
                    {{ topic.totalBlogs === 1 ? 'Article' : 'Articles' }}</span
                  >
                </div>
              </a>
            }
          </div>
        </div>
      </div>
    </section>
  }

  <section>
    <div class="container">
      <div class="sav-section-head">
        <div>
          <h2>All Topics Directory</h2>
          <p>Browse SavingArena topics alphabetically.</p>
        </div>
      </div>

      <div class="sav-alpha-wrapper">
        <div class="sav-alphabet-nav">
          @for (entry of alphabet(); track entry.letter) {
            <button
              type="button"
              [disabled]="!entry.hasTopics"
              [class.is-active]="activeLetter() === entry.letter"
              (click)="toggleLetter(entry.letter)"
            >
              {{ entry.letter }}
            </button>
          }
        </div>

        @if (directoryTopics().length > 0) {
          <div class="sav-alpha-columns">
            @for (topic of directoryTopics(); track topic.slug) {
              <a [routerLink]="'/blogs/' + topic.slug">{{ topic.name }}</a>
            }
          </div>
        } @else if (loaded()) {
          <div class="sav-alpha-empty">
            <p>No topics match that filter.</p>
            <button type="button" (click)="clearFilters()">Show all topics</button>
          </div>
        }
      </div>
    </div>
  </section>

  <section>
    <div class="container">
      <div class="sav-cta-box">
        <div class="sav-cta-copy">
          <!-- `type-on-dark` is the site's marker for a heading on a brand band. Without it the
               global heading colour wins over the panel's own white, which is why this read as near
               black on purple. -->
          <h2 class="type-on-dark">Explore More Ways To Save</h2>
          <p>Browse coupons, stores, latest deals and complete shopping guides.</p>
        </div>

        <div class="sav-cta-links">
          <a [routerLink]="'/coupons'">All Coupons</a>
          <a [routerLink]="'/collection'">Latest Deals</a>
          <a [routerLink]="'/storelist'">Stores</a>
          <a [routerLink]="'/blogs'">Blogs</a>
        </div>
      </div>
    </div>
  </section>
</main>
